import React from "react";

const Config = () => {
  return (
    <div>
      <h1>Configuration</h1>
    </div>
  );
};

export default Config;
